import React, { Component } from 'react'

import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'

import ImgBankPhotoSelection from './index'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

class ImgBankPhotoSelectionModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    event: PropTypes.object,
    dates: PropTypes.array,
    currentDay: PropTypes.number,
    user: PropTypes.object,
    onFileChange: PropTypes.func,
    index: PropTypes.number
  }

  static defaultProps = {
    isOpen: false
  }

  render() {
    const { isOpen, onClose, user, t } = this.props
    return (
      <Modal show={isOpen} onHide={() => onClose(this.props.index)} dialogClassName="gallery_modal" aria-labelledby="ModalHeader">
        <Modal.Body>
          <ImgBankPhotoSelection
            t={t}
            user={user}
            maxCanBeSelected={1}
            onSave={e => {
              this.props.onFileChange(e)
              onClose(this.props.index)
            }}
          />
          <i
            className="event-modal__close icon-close"
            onClick={() => {
              console.log(this.props.index)
              onClose(this.props.index)
            }}
          />
        </Modal.Body>
      </Modal>
    )
  }
}

const enhance = compose(translate('img_bank'))
export default enhance(ImgBankPhotoSelectionModal)



// WEBPACK FOOTER //
// src/components/ImgBankPhotoSelection/ImgBankPhotoSelectionModal.js